import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'ACCES_DOSS',
  title: 'Wie kann ich auf die Archive meines Nachunternehmers zugreifen?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Die Archive entsprechen den gültigen Dokumenten. Sie werden für einen Zeitraum von 15 Jahren gelagert.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie im Ordner Ihres Nachunternehmers auf Archive.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ACCES_DOSS/DE_ACCES_DOSS.png`
  }]
};
